import { render, staticRenderFns } from "./ResetTwoFa.vue?vue&type=template&id=dedd4392&"
import script from "./ResetTwoFa.vue?vue&type=script&lang=js&"
export * from "./ResetTwoFa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports